export default "__VITE_ASSET__CVmytV3P__";